export class PropTenantAttributeCode {
  Ptac_TenantAttributeCodeID: string;
  Ptac_Description: string;
  // ,[Ptac_PrintStatus]
  Ptac_Caution: boolean;
  Ptac_TextAnonymisationBehaviour: TextAnonymisationBehaviour;
  Ptac_AlternateText: string;
}

export enum TextAnonymisationBehaviour {
  NotAnonymised = "NotAnonymised",
  AlternateText = "AlternateText"
}
